import { useSettings } from "@repo/ui";

type UseAiFeatureConfigOptions =
  | {
      feature: "coworkerPortfolioSummary";
      buCodes?: string[];
    }
  | {
      feature: "projectSummary";
      buCode?: string;
    }
  | {
      feature: "generatedProjects";
    };

export const useAiFeatureConfig = (options: UseAiFeatureConfigOptions) => {
  const { feature } = options;
  const { ai_features_config } = useSettings();

  if (feature === "projectSummary") {
    const { buCode } = options;

    if (ai_features_config?.enable_project_summary) {
      return true;
    }

    if (!buCode) {
      return false;
    }

    return (
      ai_features_config?.enabled_project_summary_stores?.includes(buCode) ||
      false
    );
  }

  if (feature === "coworkerPortfolioSummary") {
    const { buCodes } = options;

    if (ai_features_config?.enable_coworker_portfolio_summary) {
      return true;
    }

    if (!Array.isArray(buCodes) || buCodes.length === 0) {
      return false;
    }

    return ai_features_config?.enabled_portfolio_summary_stores?.some((store) =>
      buCodes.includes(store)
    );
  }

  if (feature === "generatedProjects") {
    return ai_features_config?.enable_generated_projects ?? false;
  }
};
